import { render, staticRenderFns } from "./BenefitCardTable.vue?vue&type=template&id=fb31bbe8&"
import script from "./BenefitCardTable.vue?vue&type=script&lang=js&"
export * from "./BenefitCardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports